import Vue from "vue";
import request from "@/util/http";
import { bpmnSecurityLogin } from "@/api/login";
const headers = () => {
  return {
    headers: {
      token: window.sessionStorage.bpmnSid,
    },
  };
};
// let loginBpmnTime=window.sessionStorage.loginBpmnTime;

// 流程登录状态
const bpmnSecurityLoginHandle = () => {
  let params = {
    userName: JSON.parse(window.sessionStorage.userData).userName,
    deviceType: "pc",
  };
  return new Promise((resolve, reject) => {
    bpmnSecurityLogin(params)
      .then(({ data }) => {
        if (data.code == 0) {
          window.sessionStorage.loginBpmnTime = "" + Date.now();
          window.sessionStorage.bpmnSid = data.data.sid;
          document.cookie = data.data.cookie;
          resolve(data);
        } else {
          reject(data);
          Vue.prototype.$message.warning("流程系统业务繁忙，请稍后再试");
        }
      })
      .catch(error => {
        reject(error);
        Vue.prototype.$message.warning("流程系统业务繁忙，请稍后再试");
      });
  });
};

// 个人中心统计流程
export const bpmnCountPersonProcess = () => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/countPersonProcess",
    method: "post",
  });
};

// 按服务统计分页
export const bpmnPageProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageProcess",
    method: "post",
    params,
  });
};

// tab统计分页
export const bpmnPageProcessStatus = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageProcessStatus",
    method: "post",
    params,
  });
};

// 获取个人已处理的流程
export const bpmnPageHasdoneProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageHasdoneProcess",
    method: "post",
    params,
  });
};
// 我的个人任务
export const getMyReportList = params => {
  return request({
    ...headers(),
    url: "/admin/tHallBatchReport/getMyReportList",
    method: "get",
    params,
  });
};

//
// 按时间统计发起流程和已办流程
export const bpmnCountProcessByTime = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/countProcessByTime",
    method: "post",
    params,
  });
};

// 获取自己发起的流程
export const bpmnPageOwenProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageOwenProcess",
    method: "post",
    params,
  });
};

// 获取个人未处理的流程
export const bpmnPageTodoProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageTodoProcess",
    method: "post",
    params,
  });
};

// 开始流程
export const bpmnStartProcess = params => {
  return new Promise((resolve, reject) => {
    bpmnSecurityLoginHandle().then(() => {
      request({
        ...headers(),
        url: "/admin/bpmn/process/startProcess",
        method: "post",
        params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  });
};

// 开始流程(新)
export const bpmnStartProcessNew = params => {
  return new Promise((resolve, reject) => {
    bpmnSecurityLoginHandle().then(() => {
      request({
        ...headers(),
        url: "/admin/tHallBatchReport/startReport",
        method: "post",
        data: params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  });
};

// 监督头统计
export const bpmnHeadStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/headStastic",
    method: "post",
    params,
  });
};

// 饼图
export const bpmnChatStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/pieChatStastic",
    method: "post",
    params,
  });
};

// 服务分页
export const bpmnPageServeStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/pageServeStastic",
    method: "post",
    params,
  });
};

// 部门分页
export const bpmnPageDeptStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/pageDeptStastic",
    method: "post",
    params,
  });
};

// Detail
export const bpmnPageServeDetailProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/pageServeDetailProcess",
    method: "post",
    params,
  });
};

// 统计学生和教师的服务
export const bpmnStuAndteachStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/stuAndteachStastic",
    method: "post",
    params,
  });
};

// 统计学生和教师的服务
export const bpmnByTimesStastic = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/stastics/bpmnByTimesStastic",
    method: "post",
    params,
  });
};

// 我的消息
export const bpmnPageBpmnNotice = params => {
  return request({
    ...headers(),
    url: "/admin/messageCenter/page",
    method: "post",
    params,
  });
};
// 单条标记已读
export const setUserRead = params => {
  return request({
    ...headers(),
    url: "/admin/messageCenter/setUserReaded",
    method: "get",
    params,
  });
};
// 全部标记已读
export const setUserAllRead = params => {
  return request({
    ...headers(),
    url: "/admin/messageCenter/setUserAllReaded",
    method: "get",
    params,
  });
};
// 我的消息查看详情
export const bpmnNoticeVisitUrl = params => {
  return new Promise((resolve, reject) => {
    bpmnSecurityLoginHandle().then(() => {
      request({
        ...headers(),
        url: "/admin/bpmn/process/noticeVisitUrl",
        method: "post",
        params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  });
};

// 上报
export const bpmnSubmitMyReport = data => {
  return request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "/admin/tHallBatchReport/submitMyReport",
    method: "post",
    data: JSON.stringify(data),
  });
};

export const exportServeStastic = data => {
  return request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "/admin/bpmn/stastics/exportServeStastic",
    method: "post",
    data: data,
  });
};

export const unreadCount = () => {
  return request({
    url: "/admin/messageCenter/unreadCount",
    method: "post",
  });
};

// 单个服务使用信息
export const singleServeStatic = params => {
  return request({
    ...headers(),
    url: `/admin/bpmn/stastics/singleServeStatic`,
    method: "post",
    params,
  });
};

// 我的服务审批
export const myAffSp = params => {
  return request({
    ...headers(),
    url: `/admin/bpmn/batchApproval`,
    method: "post",
    data: params,
  });
};

// 我的服务-抄送数量
export const getNumCs = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/countUnreadCcopyNum",
    method: "get",
    params,
  });
};
export const getPageCs = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/pageCcopy",
    method: "post",
    params,
  });
};
export const getMsgStatus = params => {
  return request({
    ...headers(),
    url: "/jsaas/sys/db/sysSqlCustomQuery/queryForJson_qfwhts.do",
    method: "post",
    params: { params },
  });
};
// 删除流程实例
export const delBpmId = params => {
  return request({
    ...headers(),
    url: `/admin/bpmn/process/delInst`,
    method: "post",
    params,
  });
};
//草稿
export const myDraftsProcess = params => {
  return request({
    ...headers(),
    url: "/admin/bpmn/process/myDraftsProcess",
    method: "post",
    params,
  });
};
